module.exports = __webpack_public_path__ + "img/public.4227983f.svg";